import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { apiOrganization } from "../../../../../../../../../../services/Api/Organization/apiOrganization";
import ClientForm from "../../components/ClientForm";

const OrganizationClientsIndexNewPage = (): JSX.Element => {
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>();
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { addFlash } = useFlash();

	const fetchCustomFields = async () => {
		try {
			const cfParams = {
				f: btoa(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}resource_type|e=CLIENT`),
				include: "options,constraints",
			};
			const customFields = await apiOrganization.getCustomFields(cfParams);
			setCustomFieldsConfig(customFields);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	useEffect(() => {
		fetchCustomFields();
		handleChangeTabTitle(t("modules.client.header.new.title"));
	}, []);

	if (!customFieldsConfig) {
		return <LoadingContainer />;
	}

	return (
		<>
			<Header title={t("modules.client.header.new.title")} />
			<ClientForm customFieldsConfig={customFieldsConfig} />
		</>
	);
};
export default OrganizationClientsIndexNewPage;
